import type { IQuizVersionRepository } from '@/core/domain/quiz/IQuizVersionRepository.ts'
import type { QuizVersion } from '@/core/domain/quiz/QuizVersion.ts'

export class FetchQuizVersionByIdUseCase {
  private readonly quizVersionRepository: IQuizVersionRepository

  constructor(quizVersionRepository: IQuizVersionRepository) {
    this.quizVersionRepository = quizVersionRepository
  }

  async execute(id: number): Promise<QuizVersion> {
    return await this.quizVersionRepository.fetchQuizVersionById(id)
  }
}